import { ChangeEvent, useRef, useState } from 'react';
import { Button, Divider } from '@ds';
import { ConditionalRender } from '@ui';
import { MAX_FILES_AMOUNT } from '@features/config/files/files.config';
import { RedactionConfirmationCheckbox } from './RedactionConfirmationCheckbox';

const acceptExtensions = '.pdf,.docx,.doc,.mov,.mp4,.hevc,.jpg,.jpeg,.png,.heic,.hevс';

type FilesUploadControlProps = {
  filesCount: number;
  isUploading: boolean;
  onFileUpload: (e: ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  requireRedactionConfirmation?: boolean;
};

export const FilesUploadControl = ({
  filesCount,
  isUploading,
  onFileUpload,
  disabled,
  requireRedactionConfirmation = false,
}: FilesUploadControlProps) => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [isRedactionConfirmed, setIsRedactionConfirmed] = useState(false);

  const onUploadButtonClick = () => {
    fileInputRef?.current?.click();
  };

  const onFileInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    onFileUpload(e);
    if (requireRedactionConfirmation) setIsRedactionConfirmed(false);
  };

  const isRedactionConfirmationPending = requireRedactionConfirmation && !isRedactionConfirmed;

  return (
    <div className="shrink-0 bg-base-80">
      <Divider />
      <div className="py-4 flex items-center justify-end gap-3">
        <ConditionalRender show={requireRedactionConfirmation}>
          <RedactionConfirmationCheckbox isSelected={isRedactionConfirmed} onValueChange={setIsRedactionConfirmed} />
        </ConditionalRender>
        <input
          multiple
          className="hidden"
          accept={acceptExtensions}
          ref={fileInputRef}
          onChange={onFileInputChange}
          type="file"
        />
        <Button
          size="md"
          isDisabled={isUploading || filesCount >= MAX_FILES_AMOUNT || disabled || isRedactionConfirmationPending}
          className="text-m-sb"
          variant="outline"
          onPress={onUploadButtonClick}
          isLoading={isUploading}
        >
          + Add Item
        </Button>
      </div>
    </div>
  );
};
